import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  attendees: [],
  totalAttendeePages: 0,
  totalAttendeeItems: 0,
  regularAttendeeStatusesCount: null
}

const getters = {
  regularAttendeeList: state => state.attendees,
  totalAttendeePages: state => state.totalAttendeePages,
  totalAttendeeItems: state => state.totalAttendeeItems,
  getRegularAttendeeStatusesCount: state => state.regularAttendeeStatusesCount
}

const actions = {
  async getRegularAttendeeList ({commit}, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.attendee.getRegularAttendee(payload))
      commit(types.SET_REGULAR_ATTENDEE_LIST, response.data)
    } catch (err) {
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setAttendeeApproveStatus ({commit}, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.attendee.setApproveStatus(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Status was changed to approved')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, err.response.data.Message)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async receiveFullAttendeeInfo ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.attendee.recieveFullDataAboutAttendee(id))
      return data
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Regular attendee type wasn\'t fetch')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editRegularAttendee ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.attendee.editRegularAttendee(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Attendee was updated!')
    } catch (err) {
      let message = err.response.data.ValidationFailures.map(el => {
        return ` ${el.errorMessage}`
      })
      commit(types.CREATE_ERROR_MESSAGE, `${message}`)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchRegularAttendeeStatusesCount ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.attendee.getStatusesCount())
      commit(types.SET_REGULAR_ATTENDEE_STATUSES_COUNT, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to get statuses count')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async sendRequestForPayment ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.attendee.sendRequestForPayment(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Request was sent!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, err.response.data.Message)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async sendRequestForPhoto ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.attendee.sendRequestForPhoto(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Request was sent!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, err.response.data.Message)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_REGULAR_ATTENDEE_LIST] (state, {attendees, totalPages, totalItems}) {
    state.attendees = [...attendees]
    state.totalAttendeePages = totalPages
    state.totalAttendeeItems = totalItems
  },
  [types.SET_REGULAR_ATTENDEE_STATUSES_COUNT] (state, data) {
    state.regularAttendeeStatusesCount = data.statusesCount
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/regularAttendee.js